import { render, staticRenderFns } from "./DuitieZhutu.vue?vue&type=template&id=ee674412&scoped=true&"
import script from "./DuitieZhutu.vue?vue&type=script&lang=js&"
export * from "./DuitieZhutu.vue?vue&type=script&lang=js&"
import style0 from "./DuitieZhutu.vue?vue&type=style&index=0&id=ee674412&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee674412",
  null
  
)

export default component.exports